document.addEventListener("DOMContentLoaded", function () {
  const extoleZone = document.querySelector("#extole_zone_global_footer");
  if (!extoleZone) return;

  const footerContainer = document.querySelector("footer.footer");

  if (footerContainer) {
    footerContainer.addEventListener("click", function (e) {
      if (e.target.closest(".js-footer-refer")) {
        e.preventDefault();
        try {
          extoleZone.click();
        } catch (error) {
          console.error("Failed to trigger refer-a-friend:", error);
        }
      }
    });
  }
});
